import './Milestones.scss';

// The counterweight. Everything above this point argues return — reach, the
// ask, the campaign — which quietly tells a bride, or a parish marking its
// centenary, that they're on the wrong site. They aren't, and this says so.
//
// Placed after Services on purpose: Services already lists Wedding, Short Film,
// and Feature Film under Miscellaneous, where they read as an afterthought.
// This gives them a reason.
const MILESTONES = [
    {
        title: "A wedding",
        body: `One day, told the way it actually felt — for the people who were there
               and the ones who couldn't be.`,
    },
    {
        title: "An anniversary",
        body: `A hundred years of a parish, twenty-five of a business, the last season
               in a building you're about to leave.`,
    },
    {
        title: "An event, captured",
        body: `The ordination, the gala, the festival, the final performance. Filmed
               properly the first time, because there isn't a second one.`,
    },
    {
        title: "Someone worth recording",
        body: `The pastor retiring, the founder stepping back, the volunteer who has
               been there forty years. Recorded while you still can.`,
    },
];

function Milestones() {
    return (
        <div className="Milestones" id="milestones">
            <div className="Milestones-header-container reveal">
                <span className="Milestones-eyebrow">Not everything is a campaign</span>
                <h2 className="Milestones-header">
                    Some films just <span>need to exist.</span>
                </h2>
                <p className="Milestones-lead">
                    Not everything worth filming has a return attached to it. Some things
                    are worth keeping because of what they were.
                </p>
            </div>

            <div className="Milestones-list reveal">
                <ul>
                    {MILESTONES.map(item => (
                        <li key={item.title}>
                            <b>{item.title}</b>
                            <span>{item.body}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default Milestones;
